export default __webpack_public_path__ + "static/media/36I-102609_-15498_0.603304ff.jpg";